import { render } from "./SalaryReviews.vue?vue&type=template&id=7f57f6be"
import script from "./SalaryReviews.vue?vue&type=script&lang=js"
export * from "./SalaryReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__